"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _registerBasicData = _interopRequireDefault(require("./registerBasicData"));

require("../../moment/moment-and-timezone-init");

require("../../moment/allSupportedMomentLocales");

var _default = function _default(Provider) {
  return (0, _registerBasicData.default)(Provider);
};

exports.default = _default;
module.exports = exports.default;